import * as Const from './const';
import Util from '@/core/utils';
import dayjs from 'dayjs';
import Api from '@/core/api';


const SUBJECT = Const.SUBJECT;
const STATUS = Const.STATUS;
const CUSTOM_TYPE = Const.CUSTOM_TYPE;

const MONEY_TYPE = Const.MONEY_TYPE;
const PURSUE_STATUS = Const.PURSUE_STATUS;

const CAR_OCCUPY_MODE = Const.CAR_OCCUPY_MODE;

const ORDER_STATUS = Const.ORDER_STATUS;
const ORDER_STATUS_MARK = Const.ORDER_STATUS_MARK;

const REFUND_MARK = Const.REFUND_MARK;
const REFUND_STATUS = Const.REFUND_STATUS;

const CUSTOM_ORDER_TYPE = Const.CUSTOM_ORDER_TYPE;

const format = 'YYYY-MM-DD HH:mm:ss';
const formatDate = 'YYYY-MM-DD';
const formatTime = 'HH:mm';

/** 划分时间段 */
function splitTimeRange(startTime, endTime, splitPoints) {
	const result = [];

	let startSecond = dayjs.unix(startTime).second();
	let endSecond = dayjs.unix(endTime).second();

	let currTime = dayjs.unix(startTime).millisecond(0);
	endTime = dayjs.unix(endTime).millisecond(999);

	splitPoints.forEach((i) => {
		i.split_time = dayjs(currTime).hour(i.hour).minute(i.minute).second(59).millisecond(999);
	});

	while (currTime.valueOf() < endTime.valueOf()) {
		// console.log('splitTimeRange currTime.valueOf()', currTime.valueOf(), 'endTime.valueOf():', endTime.valueOf(), endTime.valueOf() - currTime.valueOf());

		// 获取当前日期的分割点
		let todaySplitPoints = splitPoints;
		todaySplitPoints.forEach((i) => {
			// dayjs(i.split_time).date(currTime.date())
			i.today_split_time = dayjs(i.split_time).year(currTime.year()).month(currTime.month()).date(currTime.date());
		});

		for (const item of todaySplitPoints) {
			if (currTime.valueOf() < item.today_split_time.valueOf() && currTime.valueOf() < endTime.valueOf()) {
				let end = dayjs(Math.min(item.today_split_time.valueOf(), endTime.valueOf()));
				result.push({
					...item,
					calc_date: dayjs(currTime).format(formatDate), // 当天日期
					calc_start: dayjs(currTime).format(format), // 开始时间  年月日时分秒
					calc_end: end.format(format), // 结束时间  年月日时分秒
					calc_start_time: dayjs(currTime).format(formatTime), // 开始时间  时分秒
					calc_end_time: end.format(formatTime), // 结束时间  时分秒
					calc_start_second: startSecond,  // 开始时间的分钟数
					calc_end_second: endSecond,  // 结束时间的分钟数
					// calc_occupy_minute: Math.ceil(dayjs(end).diff(dayjs(currTime), 'minute')), // 计算的占位分钟
					// calc_occupy_minute_1: getOccupyMinute(currTime.second(second).unix(), end.second(59).unix()), // 计算的占位分钟
				});
				currTime = dayjs(end).add(1, 'millisecond');

				// console.log('splitTimeRange for currTime:', currTime.format(format));
			}
		}

		// 跳到下一天
		// currTime = dayjs(currTime.add(1, 'd').startOf('d'))

		// console.log('splitTimeRange currTime:', currTime.format(format));
	}

	return result;
}

/** 计算占位金额列表数据占位时长 */
function getOccupyMinuteByPriceList(startTime, result) {
	try {
		if (!result.length || !startTime) return [];

		for (let i = 0; i < result.length; i++) {
			const item = result[i];
			let itemBegin = 0;
			if (i === 0) {
				itemBegin = startTime;
			} else {
				const itemPrev = result[i - 1];
				itemBegin = dayjs(itemPrev.calc_end).second(itemPrev.calc_start_second).unix();
			}

			let itemEnd = dayjs(item.calc_end).second(59).unix();

			item.calc_occupy_minute = getOccupyMinute(itemBegin, itemEnd);
			if (i === result.length - 1 && item.calc_end_second > item.calc_start_second) {
				item.calc_occupy_minute += 1;
			}

			item.calc_occupy_price = item.calc_occupy_minute * item.price; // 计算的占位费用
		}
		return result;
	} catch (err) {
		console.log("getOccupyMinuteByPriceList err:", err)
		return result;
	}
}

/** 计算每个时段占位时长 */
function getOccupyMinute(begin, end) {
	try {
		let minute = 0;
		if (!begin || !end) return 0
		const step = 60;
		let time = begin + step;
		while (time <= end) {
			minute++;
			time += step;
		}
		return minute;
	} catch (errr) {
		return 0;
	}
}

/**
 * 获取跨天的占位金额数据
 * @param {*} startTime                  开始时间   时间戳
 * @param {*} endTime                    结束时间   时间戳
 * @param {*} occupyConfig               占位配置
 * @returns  result   时段占位花费结果
 */
export function getOccupyPriceList(startTime = 0, endTime = 0, occupyConfig = {}, detail = {}) {
	try {
		if (Util.isEmptyObj(occupyConfig) || !startTime || !endTime || Util.isEmptyObj(detail)) return [];

		// 充电后占位配置
		let charge_finish_occupy_fee_config = occupyConfig.charge_finish_occupy_fee_config || {};
		if (Util.isEmptyObj(charge_finish_occupy_fee_config)) return [];

		let result = [];

		switch (occupyConfig.charge_mode) {
			case CAR_OCCUPY_MODE.TIME: // 实时计费
				// 定义分割点
				let splitPoints = [];
				splitPoints = charge_finish_occupy_fee_config.occupy_list || [];

				// 划分时间段
				result = splitTimeRange(startTime, endTime, splitPoints);

				// 计算占位金额列表数据占位时长
				result = getOccupyMinuteByPriceList(startTime, result);

				break;
			case CAR_OCCUPY_MODE.MONEY: // 一口价
				result = [
					{ 
						calc_start_time: dayjs.unix(startTime).format(format), 
						calc_end_time: dayjs.unix(endTime).format(format), 
						calc_occupy_price: charge_finish_occupy_fee_config.occupy_price || 0 
					}
				];
				break;
		}

		// 有金额显示
		result = result.filter(i => i.calc_occupy_price);

		// 输出结果
		// console.log("getOccupyPriceList result:", result);
		return result;
	} catch (err) {
		console.log('getOccupyPriceList err:', err);
		return [];
	}
}

/** 费用科目 */
export function subjectFilter(val, to = 'text') {
	const MAP = Const.SUBJECT_MAP || {};
	const ITEM = MAP[val + ''] || {};
	return ITEM[to] || '';
}

/** 收支方式 */
export function methodFilter(val, to = 'text') {
	const ITEM = Const.PAY_METHOD_MAP[val + ''] || {};
	return ITEM[to] || '';
}

/** 状态 */
export function statusFilter(val, to = 'text') {
	const ITEM = Const.STATUS_MAP[val + ''] || {};
	return ITEM[to] || '';
}

// 订单详情
let detail = {};

let pursueDetail = {};

// 存放按时间排列的
let tableData = [];
let tableInfo = {};

// 费用
let fee = {};

// flag
let flag = {};

function reset() {
	detail = {};
	pursueDetail = {};
	tableData = [];
	tableInfo = {};
	fee = {};
	flag = {};
}

/** flag */
export function getFlag(detail = {}) {
	const flag = {
		is_pay: false, // 是否支付

		occupying: false, // 占位中
	};

	// 占位中
	flag.occupying = ORDER_STATUS_MARK.NOT_FINISH.includes(detail.status);

	if (detail.status !== ORDER_STATUS.UNPAY) {
		flag.is_pay = true;
	}

	return flag;
}

/** 支付明细 */
export async function markPayDetails(d = {}) {
	try {
		if (Util.isEmptyObj(d)) {
			throw {
				message: '获取占位订单详情错误',
			}
		};

		reset();

		detail = d;

		flag = getFlag(d);

		// 有欠款
		if (d.pursue_order_id) {
			await getPursueOrder(d.pursue_order_id);
		}

		const temp = {
			subject: SUBJECT.PRE_OCCUPY,
			method: d.pay_method,
			card_uid: d.card_uid,
			status: STATUS.SUCCESS,
			order_type: CUSTOM_ORDER_TYPE.occupy,
		};

		// 已收金额
		tableInfo.use = {
			...temp,
			price: d.price || 0,
			time: d.create_time,
			type: MONEY_TYPE.INCOME,
			custom_type: CUSTOM_TYPE.receivable,
		};

		// 占位结束
		if (!flag.occupying) {
			// 占位退款
			if (d.price > d.charge) {
				tableInfo.refund = {
					...temp,
					price: (d.price - d.charge) || 0,
					time: d.end_time,
					type: MONEY_TYPE.OUTPAY,
					custom_type: CUSTOM_TYPE.refund,
				};
			}
		}

		// 二次退款
		if (d.refund_status !== 0) {
			tableInfo.refund_after = {
				...temp,
				price: d.refund_money || 0,
				time: d.refund_time,
				type: MONEY_TYPE.OUTPAY,
				status: REFUND_MARK.REFUNDING.includes(d.refund_status) ? STATUS.DOING : (d.refund_status === REFUND_STATUS.ALL_SUCCESS ? STATUS.SUCCESS : STATUS.FAILURE),
				custom_type: CUSTOM_TYPE.refund,
			};
		}

		// 获取表格数据
		getTableData();

		// 获取费用
		getFee();

		return {
			tableData,
			fee,
			flag,
		};
	} catch (err) {
		console.log('markPayDetails err:', err);
		return {};
	}
}

/** 获取表格数据 */
function getTableData() {
	let tableInfoData = Object.values(tableInfo) // 表格数据
	// console.log("getTableData tableInfoData:", tableInfoData);
	tableData = sortByTime(tableInfoData);
	// console.log("getTableData tableData:", tableData);
}

/** 排序 */
function sortByTime(list) {
	list = list.filter(item => !Util.isEmptyObj(item) && item.price)

	// price为0  也要显示
	// list = list.filter((item) => !Util.isEmptyObj(item));

	return list
		.sort((a, b) => b.time - a.time)
		.map((item) => {
			return {
				...item,
				price: Math.abs(item.price),
			};
		});
}

/** 获取费用 */
function getFee() {
	let price = {
		total: 0, // 占位金额
		receivable: 0, // 已收金额
		refund: 0, // 退款金额
		debt: 0, // 欠款金额
	};

    tableData.forEach(i => {
        if (i.custom_type === CUSTOM_TYPE.receivable) {
            price.receivable += i.price;
        } else if (i.custom_type === CUSTOM_TYPE.refund) {
            price.refund += i.price;
        } else if (i.custom_type === CUSTOM_TYPE.debt) {
            price.debt += i.price;
        }
    })
	
	// 已收金额
	price.receivable -= price.refund;

    // 占位金额
    price.total = price.receivable + price.refund + price.debt;

	fee = price;
}

/** 获取欠款订单 */
async function getPursueOrder(id) {
	try {
		if (!id) return;

		let res = await Api.PursueOrder.detail({
			id,
		});
		console.log('getPursueOrder res:', res);
		pursueDetail = res;

		const temp = {
			subject: SUBJECT.PRE_OCCUPY,
			method: pursueDetail.pay_method,
			card_uid: pursueDetail.card_uid,
			status: STATUS.SUCCESS,
			order_type: CUSTOM_ORDER_TYPE.pursue,
		};

		switch (pursueDetail.status) {
			case PURSUE_STATUS.WAIT_PAY:  // 等待支付
				tableInfo.pursue = {
					...temp,
					price: pursueDetail.price || 0,
					time: pursueDetail.create_time,
					type: MONEY_TYPE.INCOME,
					custom_type: CUSTOM_TYPE.debt,
					status: STATUS.DOING,
					hide: true,
				};
				break;
			case PURSUE_STATUS.PAYED:  // 支付完成
			case PURSUE_STATUS.REFUNDING:  // 余额退款中
			case PURSUE_STATUS.REFUNDED:  // 退款成功
				tableInfo.pursue = {
					...temp,
					price: pursueDetail.price || 0,
					time: pursueDetail.pay_time,
					type: MONEY_TYPE.INCOME,
					custom_type: CUSTOM_TYPE.receivable,
				};
				break;
		}

		// 二次退款
		if (pursueDetail.refund_status !== 0 && pursueDetail.price > pursueDetail.charge) {
			tableInfo.pursue_after = {
				...temp,
				price: (pursueDetail.price - pursueDetail.charge) || 0,
				time: pursueDetail.refund_time,
				type: MONEY_TYPE.OUTPAY,
				status: REFUND_MARK.REFUNDING.includes(pursueDetail.refund_status) ? STATUS.DOING : (pursueDetail.refund_status === REFUND_STATUS.ALL_SUCCESS ? STATUS.SUCCESS : STATUS.FAILURE),
				custom_type: CUSTOM_TYPE.refund,
			};
		}

        
	} catch (err) {
        console.log("getPursueOrder err:", err);
    }
}
